<template>
  <v-footer dark absolute height="55">
    <v-layout column>
      <v-breadcrumbs :items="links" divider="|" class="align-center justify-center ma-0 pa-0">
        <li slot="divider" class="caption"> | </li>
        <template slot="item" slot-scope="props">
          <TermsViewer v-if="props.item.method === 'dialog'" :buttonTitle="props.item.label" :title="props.item.label" :src="props.item.link" :id="props.item.id" :data_ffid="props.item.data_ffid"></TermsViewer>
          <li v-if="props.item.method === 'browse' || props.item.method === 'email'" v-ripple slot="activator" class="footer-btn text-xs-center caption" style="cursor:pointer;" @click="takeLink(props.item.link)" :data_ffid="props.item.data_ffid">{{props.item.label}}</li>
        </template>
      </v-breadcrumbs>
    </v-layout>
  </v-footer>
</template>

<script>

import TermsViewer from '@/components/TermsViewer'

const termsDir = './terms/'

export default {
  name: 'FooterItem',
  components: {
    TermsViewer
  },
  data () {
    return {
      isCanada: false,
      links: []
    }
  },
  mounted () {
    // check hosting domain for Canada
    this.isCanada = window.location.hostname.includes('.ca')
    this.links = [
      { label: window.i18n.t('webTransfer.privacyPolicy'), link: this.getLink('privacy-policy'), method: 'dialog', id: 'privacyPolicyLink', data_ffid: 'privacy-footer-link' },
      { label: this.isCanada ? window.i18n.t('webTransfer.termsConditionsCA') : window.i18n.t('webTransfer.termsConditions'), link: this.getLink('terms'), method: 'dialog', id: 'termsLink', data_ffid: 'terms-footer-link' }
    ]
    if (this.isCanada) {
      let canadianExtraLinks = [
        { label: window.i18n.t('webTransfer.acceptableUsePolicy'), link: this.getLink('acceptableUsePolicy'), method: 'dialog', id: 'acceptableUsePolicyLink', data_ffid: 'acceptableUse-footer-link' },
        { label: window.i18n.t('webTransfer.contactUs'), link: this.getContactLink(), method: 'browse', data_ffid: 'contactUs-footer-link' } // open in new browser window/tab
      ]
      this.links = this.links.concat(canadianExtraLinks)
    }
  },
  props: {
    src: {},
    title: {},
    buttonTitle: {},
    id: {}
  },
  methods: {
    // hasNotch () {
    //   // this code unfortunately does allow detection of the iPhone X home bar when in portrait orientation --
    //   // env(safe-area-inset-bottom) calculates to 0px for this while there is a height in landscape device orientation
    //   if (CSS && CSS.supports && CSS.supports('padding-bottom: env(safe-area-inset-bottom)')) {
    //     let div = document.createElement('div')
    //     div.style.paddingBottom = 'env(safe-area-inset-bottom)'
    //     document.body.appendChild(div)
    //     let calculatedPadding = parseInt(window.getComputedStyle(div).paddingBottom, 10)
    //     document.body.removeChild(div)
    //     if (calculatedPadding > 0) {
    //       return true
    //     }
    //   }
    //   return false
    // },
    getLink (which) {
      let link = termsDir + which
      if (this.isCanada) {
        link += '-' + this.$i18n.locale.toUpperCase() + '-CA'
      } else {
        link += '-EN'
      }
      link += '.html'
      return link
    },
    getContactLink () {
      let link = 'mailto:infosec-na@fujifilm.com'
      if (this.isCanada) {
        link = 'https://www.fujifilm.ca/contact_us/index.html'
      }
      return link
    },
    takeLink (which) {
      if (which.indexOf('mailto:') === 0) {
        // send email - go email, user can go 'back'
        window.location = which
      } else if (which.indexOf('http') === 0) {
        // open new browser window/tab
        window.open(which)
      }
    }
  }
}
</script>
